import { Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

export interface MetricDefinition {
  term: string;
  definition: string;
}

interface Props {
  title: string;
  metrics: MetricDefinition[];
}

export default function XeroMetricInfo({ title, metrics }: Props) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-6 w-6 text-muted-foreground hover:text-foreground"
          aria-label={`What these figures mean: ${title}`}
        >
          <Info className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-96 p-0">
        <div className="border-b border-border px-4 py-3">
          <p className="text-sm font-medium text-foreground">{title}</p>
        </div>
        {/* Plain overflow, not Radix ScrollArea: see the note in XeroPanel. */}
        <div className="max-h-80 overflow-y-auto">
          <dl className="space-y-3 px-4 py-3 text-xs">
            {metrics.map((metric) => (
              <div key={metric.term} className="space-y-0.5">
                <dt className="font-medium text-foreground">{metric.term}</dt>
                <dd className="text-muted-foreground">{metric.definition}</dd>
              </div>
            ))}
          </dl>
        </div>
      </PopoverContent>
    </Popover>
  );
}
